"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Wellness Exams",
  description: "Comprehensive health checks and preventative care to ensure your furry companions live their longest, happiest lives.",
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/wellness_exams_city_pet.png)]",
  link: "/WellnessServicesPage"
}, {
  title: "Emergency Care",
  description: "Immediate medical attention for urgent situations, providing peace of mind when every second counts for your pet.",
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/emergency_vet_care.png)]",
  link: "/EmergencyPharmacyPage"
}, {
  title: "Online Pharmacy",
  description: "Convenient access to prescription medications and premium nutrition delivered directly to your urban doorstep.",
  bgClass: "bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/pet_pharmacy_delivery.png)]",
  link: "/EmergencyPharmacyPage"
}];
export default function HowWeSupportYourPet() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: gridRef,
    isVisible: isGridVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="236396" id="how-we-support-your-pet" className="bg-background text-foreground py-24 md:py-32">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={headerRef} className={`mb-16 max-w-2xl transition-all duration-700 ease-out ${isHeaderVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0"}`}>
          <h2 className="font-default text-3xl font-bold tracking-tight text-foreground md:text-4xl lg:text-5xl">
            How We Support Your Pet
          </h2>
          <p className="mt-4 text-lg text-muted-foreground font-default leading-relaxed">
            Compassionate veterinary care tailored for the modern urban pet owner, focusing on wellness, urgency, and convenience.
          </p>
        </div>

        <div ref={gridRef} className={`grid grid-cols-1 gap-6 md:grid-cols-3 transition-all duration-1000 ease-out delay-200 ${isGridVisible ? "translate-y-0 opacity-100" : "translate-y-12 opacity-0"}`}>
          {services.map((service, i) => <div key={i} data-index={i} className="group relative h-[450px] w-full overflow-hidden rounded-lg shadow-md md:h-[550px]">
              {}
              <div className={`absolute inset-0 bg-cover bg-center transition-transform duration-1000 ease-out group-hover:scale-105 ${service.bgClass}`} />
              
              {}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent transition-opacity duration-500 group-hover:opacity-90" />

              {}
              <div className="absolute inset-0 flex flex-col justify-end p-8">
                <div className="transform transition-transform duration-500 ease-out group-hover:-translate-y-2">
                  <h3 className="font-default text-2xl font-semibold text-white md:text-3xl">
                    {service.title}
                  </h3>
                  
                  {}
                  <div className="grid grid-rows-[0fr] transition-[grid-template-rows] duration-500 ease-out group-hover:grid-rows-[1fr]">
                    <div className="overflow-hidden opacity-0 transition-opacity duration-500 delay-100 group-hover:opacity-100">
                      <p className="mt-3 mb-6 text-sm leading-relaxed text-white/90 md:text-base font-default">
                        {service.description}
                      </p>
                      <Button asChild variant="outline" className="rounded-lg border-white/40 bg-white/10 backdrop-blur-sm text-white hover:bg-white hover:text-primary transition-all duration-300">
                        <Link to={service.link}>
                          Learn More <ArrowRight className="ml-2 size-4" />
                        </Link>
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}